import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';

import { BaseComponents } from '../base.component';

export type PaymentChannel = 'qr' | 'card';

/** Payment the server started for the reference's order. */
export interface StartedPayment {
  paymentDetailID: string;
  refNo1: string;
  refNo2: string;
  voucherNumber: string;
}

/**
 * Buy-online payment start: the server issues refNo1 (rule R145) and creates the payment detail
 * of the stored order for the channel. Only the reference, its token and the channel are sent.
 */
@Injectable()
export class StartPaymentService extends BaseComponents {
  constructor(
    protected injectorObj: Injector,
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService,
  ) {
    super(injectorObj);
  }

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if (this.VERIFY_TOKEN_EXPIRE) {
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  connector(ref: string, channel: PaymentChannel) {
    const url = `${environment.endpointBackend}/api/services/buy-insurance/startPayment?ref=${ref}`;
    const body = withBuyonlineAccessToken(ref, { channel });
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  // Core Function ! No modify
  exec(ref: string, channel: PaymentChannel): Promise<StartedPayment> {
    const self = this;
    return new Promise(function (resolve, reject) {
      if (!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()) {
        self.connector(ref, channel).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            let re = res['body'];
            if (re.status && re.data?.paymentDetailID) {
              resolve(re.data);
            } else {
              reject(re);
            }
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus: 401,
          message: 'token is expired'
        });
      }
    });
  }
}
